export default __webpack_public_path__ + "static/media/181.a2987f6e.jpg";